export enum RingMap {
	HOLD = 3,
	ASSESS = 2,
	TRIAL = 1,
	ADOPT = 0,
}